/* Florage – Blogpost: Reading-Progress, Auto-TOC, Scroll-Spy, Mobile-TOC */
(function () {
  function slug(s, used) {
    var base = (s || 'abschnitt').toLowerCase()
      .replace(/[äàá]/g, 'a').replace(/[öòó]/g, 'o').replace(/[üùú]/g, 'u').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'abschnitt';
    var id = base, n = 2;
    while (used[id]) { id = base + '-' + n; n++; }
    used[id] = true;
    return id;
  }

  function init() {
    // Reading progress
    var bar = document.querySelector('[data-progress]');
    if (bar) {
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = (max > 0 ? Math.min(1, window.scrollY / max) * 100 : 0) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var article = document.querySelector('[data-article]');
    var tocList = document.querySelector('[data-toc-list]');
    var mobileList = document.querySelector('[data-mobile-toc-list]');
    if (!article) return;

    // Collect headings: article body H2 + FAQ title
    var used = {};
    var heads = [];
    article.querySelectorAll('.blg-prose h2').forEach(function (h) { heads.push(h); });
    var faqTitle = article.querySelector('[data-faq-title]');
    if (faqTitle) heads.push(faqTitle);

    if (heads.length < 2 || (!tocList && !mobileList)) {
      var aside = document.querySelector('[data-toc]');
      var mob = document.querySelector('[data-mobile-toc]');
      if (aside) aside.remove();
      if (mob) mob.remove();
      var layout = document.querySelector('[data-blg-layout]');
      if (layout) layout.classList.add('blg-layout--notoc');
      return;
    }

    var entries = heads.map(function (h) {
      if (!h.id) h.id = slug(h.textContent, used);
      else used[h.id] = true;
      return { id: h.id, label: h.textContent.trim(), el: h };
    });

    function buildLinks(container) {
      if (!container) return [];
      var links = [];
      entries.forEach(function (e) {
        var a = document.createElement('a');
        a.href = '#' + e.id;
        a.innerHTML = '<span class="bar"></span>';
        a.appendChild(document.createTextNode(e.label));
        a.addEventListener('click', function (ev) {
          ev.preventDefault();
          var top = e.el.getBoundingClientRect().top + window.scrollY - 88;
          window.scrollTo({ top: top, behavior: 'smooth' });
          var mob = document.querySelector('[data-mobile-toc]');
          if (mob) mob.classList.remove('is-open');
        });
        container.appendChild(a);
        links.push({ id: e.id, a: a });
      });
      return links;
    }

    var deskLinks = buildLinks(tocList);
    var mobLinks = buildLinks(mobileList);
    var allLinks = deskLinks.concat(mobLinks);

    function spy() {
      var cur = entries[0].id;
      entries.forEach(function (e) {
        if (e.el.getBoundingClientRect().top <= 150) cur = e.id;
      });
      allLinks.forEach(function (l) { l.a.classList.toggle('is-active', l.id === cur); });
    }
    window.addEventListener('scroll', spy, { passive: true });
    spy();

    // Mobile TOC toggle
    var mtBtn = document.querySelector('[data-mobile-toc-btn]');
    var mt = document.querySelector('[data-mobile-toc]');
    if (mtBtn && mt) {
      mtBtn.addEventListener('click', function () { mt.classList.toggle('is-open'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
